import { Configuration, PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import LwtApp from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/LwtApp';
import { hasAuthCookies } from '@monorepo/shared/src/util/auth-cookie-util';
import Config from '@monorepo/shared/src/config';
import ApolloProvider from '@monorepo/shared/src/providers/ApolloProvider';
import { ErrorProvider } from '@monorepo/shared/src/providers/ErrorProvider';
import GatedApp from 'components/app/GatedApp';
import AuthWrapper from 'components/modules/AuthWrapper';
import TelemetryProvider from 'state/providers/EducatorTelemetryProvider';
import i18n from 'translations';
import './App.css';

const App = (): React.ReactElement => {
  const msalInstance = new PublicClientApplication(Config.auth as Configuration);

  return (
    <MsalProvider instance={msalInstance}>
      <LwtApp i18n={i18n}>
        <ErrorProvider>
          <ApolloProvider useSSO={true}>
            <TelemetryProvider>
              <AuthWrapper useAuth={!hasAuthCookies()} instance={msalInstance}>
                <GatedApp />
              </AuthWrapper>
            </TelemetryProvider>
          </ApolloProvider>
        </ErrorProvider>
      </LwtApp>
    </MsalProvider>
  );
};

export default App;
